export default __webpack_public_path__ + "img/course-spanferkel.bd81ee34d68a2ca51d8cfc49a910f4c5.png";